import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { SET_TOKEN, LOGOUT } from "./login/Types";
import { FHTChatId } from "@/common/FHTChatId";
import { OPEN_CONTACT, FAILED_TO_LOAD_CONTACTS } from "./chat/contacts/Types";
import { UPDATE_UNREAD_MESSAGE_COUNT, RECEIVE_NEW_MESSAGE } from "./chat/messages/Types";
import { SET_IM_SESSION } from "./chat/im/Types";
import { Contact } from "@/models/Contact";
import { loadedContactFromServer, failedToLoadContacts } from "./chat/contacts/Actions";
import { sortedContactsSelector } from "./chat/contacts/Selectors";
import { assert } from "@/common/assert";
import { loadContactPersistedContactInfoFromStorage, saveContactsToStorage } from "./persistedContactIds";
import { IS_PROD } from "@/common/fhtGlobalEnv";
import { defaultHeaders } from "@/apis/api/api"; // eslint-disable-next-line @typescript-eslint/ban-types

var localStorageMiddleware = function localStorageMiddleware(store) {
  return function (next) {
    return function (action) {
      var e_1, _a;

      var result = next(action);
      var state = store.getState();

      if (!IS_PROD) {
        var chatIds = Object.keys(state.contact.contacts);

        try {
          for (var chatIds_1 = __values(chatIds), chatIds_1_1 = chatIds_1.next(); !chatIds_1_1.done; chatIds_1_1 = chatIds_1.next()) {
            var ci = chatIds_1_1.value;

            try {
              FHTChatId.decode(ci);
            } catch (err) {
              console.error("failed to decode encodedChatId of value. Make sure you do not mixin conversationIds in redux reducers", ci, err);
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (chatIds_1_1 && !chatIds_1_1.done && (_a = chatIds_1["return"])) _a.call(chatIds_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }

      switch (action.type) {
        case SET_TOKEN:
          localStorage.setItem("username", state.loginSession.loginUserName);
          localStorage.setItem("password", state.loginSession.loginPassword);
          localStorage.setItem("access_token", JSON.stringify(state.loginSession.token));
          defaultHeaders.Authorization = "bearer " + state.loginSession.token.token;
          break;

        case LOGOUT:
          localStorage.removeItem("username");
          localStorage.removeItem("password");
          localStorage.removeItem("access_token");
          delete defaultHeaders.Authorization;
          window.location.href = window.location.href; //refresh page

          break;

        case SET_IM_SESSION:
          {
            console.log("set im session");

            (function () {
              return __awaiter(void 0, void 0, void 0, function () {
                var myself, persistedContactInfos, failedToLoadConvIds, persistedContactInfos_1, persistedContactInfos_1_1, info, contact, err_1, e_2_1;

                var e_2, _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      myself = state.imSession.myself;
                      assert(myself, "gotta have myself");
                      return [4
                      /*yield*/
                      , loadContactPersistedContactInfoFromStorage(myself)];

                    case 1:
                      persistedContactInfos = _b.sent();
                      if (!persistedContactInfos.length) return [3
                      /*break*/
                      , 12];
                      failedToLoadConvIds = [];
                      _b.label = 2;

                    case 2:
                      _b.trys.push([2, 9, 10, 11]);

                      persistedContactInfos_1 = __values(persistedContactInfos), persistedContactInfos_1_1 = persistedContactInfos_1.next();
                      _b.label = 3;

                    case 3:
                      if (!!persistedContactInfos_1_1.done) return [3
                      /*break*/
                      , 8];
                      info = persistedContactInfos_1_1.value;
                      _b.label = 4;

                    case 4:
                      _b.trys.push([4, 6,, 7]);

                      return [4
                      /*yield*/
                      , Contact.getContactByFHTChatId(info.chatId, myself)];

                    case 5:
                      contact = _b.sent();
                      store.dispatch(loadedContactFromServer(contact));
                      return [3
                      /*break*/
                      , 7];

                    case 6:
                      err_1 = _b.sent();
                      console.error(err_1);
                      failedToLoadConvIds.push(info);
                      return [3
                      /*break*/
                      , 7];

                    case 7:
                      persistedContactInfos_1_1 = persistedContactInfos_1.next();
                      return [3
                      /*break*/
                      , 3];

                    case 8:
                      return [3
                      /*break*/
                      , 11];

                    case 9:
                      e_2_1 = _b.sent();
                      e_2 = {
                        error: e_2_1
                      };
                      return [3
                      /*break*/
                      , 11];

                    case 10:
                      try {
                        if (persistedContactInfos_1_1 && !persistedContactInfos_1_1.done && (_a = persistedContactInfos_1["return"])) _a.call(persistedContactInfos_1);
                      } finally {
                        if (e_2) throw e_2.error;
                      }

                      return [7
                      /*endfinally*/
                      ];

                    case 11:
                      if (failedToLoadConvIds.length) {
                        store.dispatch(failedToLoadContacts(failedToLoadConvIds));
                      }

                      _b.label = 12;

                    case 12:
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            })();

            break;
          }

        case UPDATE_UNREAD_MESSAGE_COUNT:
          {
            var myself = state.imSession.myself;

            if (myself) {
              var sortedContacts = sortedContactsSelector(state);
              saveContactsToStorage(myself, sortedContacts);
            }

            break;
          }

        case RECEIVE_NEW_MESSAGE:
          var currentContactChatId = state.contact.currentContactChatId;

          if (currentContactChatId) {
            var currentContact = state.contact.contacts[currentContactChatId];

            if (currentContact && state.imSession.chatClient) {
              state.imSession.chatClient.markContactAsRead(currentContact);
            }
          }

          break;

        case FAILED_TO_LOAD_CONTACTS:
        case OPEN_CONTACT:
          {
            var myself = state.imSession.myself;

            if (myself) {
              saveContactsToStorage(myself, sortedContactsSelector(state));
            }

            break;
          }
      }

      return result;
    };
  };
};

export default localStorageMiddleware;